
export function setToken(token) {
    return localStorage.setItem("token-user",token)
}

export function getToken() {
    return localStorage.getItem("token-user")
}